import { Controller } from "stimulus"

export default class extends Controller {
  toggle(event) {
    const dialog = event.currentTarget.commandForElement
    dialog.querySelector("input[name*=target_id]").value = event.currentTarget.dataset.feedbackTargetId
  }
}
